import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { reduxForm, Field } from "redux-form";
import FieldValidation from "../../components/Validation/FieldValidation";
import { SubmissionError } from "redux-form";
import TextField from "../../components/Fields/TextField";
import _ from "lodash";
import SvgIcon from "react-icons-kit";
import { magicWand } from "react-icons-kit/icomoon/magicWand";
import { fileText } from "react-icons-kit/icomoon/fileText";

import { IA_SEARCH_LOAD, IA_SEARCH_UNLOAD, IA_SEARCH_RESULTS_LOAD } from "../../actions/Constants";

import api from "../../api/apiUtil";

import Title from "../../components/Layout/Title";

import { toastr } from "react-redux-toastr";
import { BeatLoader } from "react-spinners";

class PesquisaIA extends React.Component {
  constructor() {
    super();
    this.state = {
      pesquisando: false,
    };
    document.addEventListener("keyup", this.keyDownHandler);
  }

  keyDownHandler = (event) => {
    if (event.keyCode === 13 && document.getElementById("searchIA")) {
      document.getElementById("searchIA").click();
    }
  };

  componentWillMount() {}

  componentWillUnmount() {
    document.removeEventListener("keyup", this.keyDownHandler);
    this.props.onUnload();
  }

  async search(values) {
    if (!values.query || !values.query.trim()) {
      throw new SubmissionError({
        query: "Por favor, digite uma pergunta para pesquisar.",
      });
    }

    this.setState({ pesquisando: true });
    toastr.info("Aguarde", "Realizando pesquisa com IA...", {
      timeOut: 0,
      component: () => {
        return <BeatLoader size={15} margin={2} color={"#58abc3"} loading={true} />;
      },
    });

    try {
      const results = await api.IA.search(values.query.trim());
      this.props.onResultsLoad(results);
      this.setState({ pesquisando: false });
      toastr.removeByType("info");

      if (!results || !results.highlighted_excerpts || results.highlighted_excerpts.length === 0) {
        toastr.info("Aviso", "Não foram encontrados resultados para essa pesquisa.");
      } else {
        const uniqueFiles = new Set(results.highlighted_excerpts.map((e) => e.source_location.filename)).size;
        toastr.success("Sucesso", `Encontrados ${uniqueFiles} arquivo(s) com ${results.highlighted_excerpts.length} trechos relevantes.`);
      }
    } catch (error) {
      this.setState({ pesquisando: false });
      toastr.removeByType("info");
      toastr.error("Erro", "Ocorreu um erro ao realizar a pesquisa. Tente novamente.");
      console.error("Erro na pesquisa IA:", error);
    }
  }

  validateValues(values) {
    const errors = {};
    if (!values.query || !values.query.trim()) {
      errors.query = "Campo obrigatório";
    }
    return errors;
  }

  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  groupExcerptsByFile(excerpts) {
    const groups = {};
    const order = [];
    for (const e of excerpts) {
      const key = e.source_location.filename;
      if (!groups[key]) {
        groups[key] = [];
        order.push(key);
      }
      groups[key].push(e);
    }
    return order.map((filename) => ({ filename, excerpts: groups[filename] }));
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} description="Pesquisa com IA" />
        <div className="content">
          <div className="row">
            <div className="col-lg-12">
              <div className="hpanel">
                <div className="panel-heading">
                  <div className="panel-tools">
                    <SvgIcon size={20} icon={magicWand} />
                  </div>
                  Pesquisar Contratos
                  <br />
                  <small>Faça perguntas em linguagem natural</small>
                </div>
                <div className="panel-body">
                  <div className="row">
                    <div className="col-lg-10">
                      <Field name="query" label="Qual a sua pergunta?" placeholder="Ex: Quais contratos de leasing?" component={TextField} type="text" validate={[FieldValidation.required]} />
                    </div>
                    <div className="col-lg-2">
                      <label>&nbsp;</label>
                      <button
                        className="btn btn-info btn-block"
                        disabled={this.state.pesquisando}
                        id="searchIA"
                        onClick={handleSubmit((values) => {
                          return new Promise((resolve, reject) => {
                            var errors = this.validateValues(values);
                            if (errors && !this.isEmpty(errors)) {
                              reject(new SubmissionError(errors));
                            } else {
                              this.search(values).then(resolve).catch(reject);
                            }
                          });
                        })}
                      >
                        {this.state.pesquisando ? "Pesquisando..." : "Pesquisar"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {this.props.results && this.props.results.answer && (
            <div className="row">
              <div className="col-lg-12">
                <div className="hpanel">
                  <div className="panel-heading">
                    <div className="panel-tools">
                      <SvgIcon size={20} icon={fileText} />
                    </div>
                    Análise do Resultado
                  </div>
                  <div className="panel-body">
                    <div className="alert alert-info">
                      <div style={{ lineHeight: "1.6", whiteSpace: "pre-line" }}>{this.props.results.answer}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {this.props.results && this.props.results.highlighted_excerpts && this.props.results.highlighted_excerpts.length > 0 && !(this.props.results.answer && this.props.results.answer.startsWith("Nenhum documento com o identificador")) && (
            <div className="row">
              <div className="col-lg-12">
                <div className="hpanel">
                  <div className="panel-heading">
                    Trechos Destacados
                    <small>
                      {this.props.results.extraction_metadata && (
                        <>
                          {" "}
                          - Método: {this.props.results.extraction_metadata.method}
                          {/* - Confiança: {(this.props.results.extraction_metadata.confidence * 100).toFixed(1)}% */}
                        </>
                      )}
                    </small>
                  </div>
                  <div className="panel-body">
                    {this.groupExcerptsByFile(this.props.results.highlighted_excerpts).map((group, gi) => (
                      <div key={gi} className="hpanel hpanel-table" style={{ marginBottom: "20px" }}>
                        <div className="panel-heading hpanel-heading-sm">
                          <div className="row">
                            <div className="col-lg-9">
                              <strong>{group.filename}</strong>
                              <span className="text-muted" style={{ marginLeft: "8px" }}>
                                {group.excerpts.length} trecho(s)
                              </span>
                            </div>
                            <div className="col-lg-3 text-right">
                              <span className="label label-info">Relevância: {Math.max(...group.excerpts.map((e) => e.relevance_score)).toFixed(2)}</span>
                            </div>
                          </div>
                        </div>
                        <div className="panel-body">
                          {group.excerpts.map((excerpt, ei) => (
                            <div key={ei}>
                              {ei > 0 && <hr style={{ margin: "15px 0" }} />}
                              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                                <small className="text-muted">
                                  <strong>Página {excerpt.source_location.page_number}</strong>
                                </small>
                                <div>
                                  <span className="label label-info">Relevância: {excerpt.relevance_score.toFixed(2)}</span>
                                  {/* <span className="label label-success" style={{ marginLeft: "5px" }}>
                                    Confiança: {(excerpt.extraction_confidence * 100).toFixed(1)}%
                                  </span> */}
                                </div>
                              </div>
                              <div
                                style={{
                                  lineHeight: "1.6",
                                  fontSize: "14px",
                                  backgroundColor: "#f9f9f9",
                                  padding: "15px",
                                  borderRadius: "4px",
                                  border: "1px solid #e5e5e5",
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: excerpt.highlighted_text.replace(
                                    /<mark class="highlight-keyword">/g,
                                    '<mark style="background-color: #ffeb3b; padding: 2px 4px; border-radius: 2px; font-weight: bold;">',
                                  ),
                                }}
                              />
                              {excerpt.matched_keywords && excerpt.matched_keywords.length > 0 && (
                                <div style={{ marginTop: "8px" }}>
                                  <small className="text-muted">
                                    <strong>Palavras-chave encontradas:</strong> {excerpt.matched_keywords.join(", ")}
                                  </small>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {this.props.results && this.props.results.citations && this.props.results.citations.length > 0 && !(this.props.results.answer && this.props.results.answer.startsWith("Nenhum documento com o identificador")) && (
            <div className="row">
              <div className="col-lg-12">
                <div className="hpanel">
                  <div className="panel-heading">Citações</div>
                  <div className="panel-body">
                    <ul>
                      {this.props.results.citations.map((citation, index) => (
                        <li key={index}>
                          <small className="text-muted">{citation}</small>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onLoad: (payload) => dispatch({ type: IA_SEARCH_LOAD, payload }),
  onResultsLoad: (payload) => dispatch({ type: IA_SEARCH_RESULTS_LOAD, payload }),
  onUnload: () => dispatch({ type: IA_SEARCH_UNLOAD }),
});

const mapStateToProps = (state) => ({
  ...state.pesquisaIA,
  currentUser: state.common.currentUser,
});

const form = reduxForm({
  form: "PesquisaIAForm",
});

export default connect(mapStateToProps, mapDispatchToProps)(form(PesquisaIA));
